<template>
    <div>

        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <div v-if="loadSkeleton">
                <SkeletonLoader tipo="table-heading, card" ruta="resumen" />
            </div>
            <v-card v-else flat>

                <v-card-title v-if="$vuetify.breakpoint.smAndDown"
                    class="px-5 font-weight-bold text-body-1 primary--text justify-center pt-0">
                    RESUMEN Y CONFIRMACIÓN
                </v-card-title>
                <v-card-text>
                    <div class="font-weight-regular text-body-2 orange--text text--darken-3 px-1 pb-3">
                        Verificá que los datos sean correctos antes de confirmar.
                    </div>
                    <v-row class="d-flex">
                        <v-col cols="12" md="6" class="d-flex">
                            <v-card class="rounded-0 pa-3 flex-grow-1" outlined>
                                <v-row dense>
                                    <v-card-title class="font-weight-bold text-body-1 primary--text pa-0 mb-3">
                                        Detalles del plan de pago
                                    </v-card-title>
                                    <v-col cols="12" class="py-0">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Tipo de plan:</span>
                                            <span class="font-weight-regular text-subtitle-1 ">
                                                {{ tipoPlanTexto }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Cantidad de cuotas:</span>
                                            <span class="font-weight-regular text-subtitle-1 ">
                                                {{ pp_aux.cancuotas || 'N/A' }} {{ cuotasLabel }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Monto cuota 1:</span>
                                            <span class="font-weight-regular text-subtitle-1 ">
                                                {{ importeCuotaUno }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col v-if="pp_aux.cancuotas > 1" cols="12" class="py-0">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Monto cuotas 2 a {{
                                                pp_aux.cancuotas }}:</span>
                                            <span class="font-weight-regular text-subtitle-1 ">
                                                {{ cuotasSiguientes }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-bold text-subtitle-1 primary--text">MONTO TOTAL
                                                FINANCIADO:</span>
                                            <span class="font-weight-bold text-subtitle-1 primary--text">
                                                {{ calculaMontoTotal }}
                                            </span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex">
                            <v-card class="rounded-0 pa-3 flex-grow-1" outlined>
                                <v-row dense>
                                    <v-card-title class="font-weight-bold text-body-1 primary--text pa-0 mb-3">
                                        Medio de pago seleccionado
                                    </v-card-title>
                                    <v-col cols="12" class="py-0 mb-2">
                                        <v-alert color="secondary" dense outlined elevation="0"
                                            :icon="cuenta.esNueva ? 'mdi-plus-circle-outline' : 'mdi-information-outline'"
                                            class="rounded-0 ma-0">
                                            <div class="text-body-2">
                                                <strong>
                                                    {{ cuenta.esNueva ? 'Se agregará una nueva' : 'Se vinculará la' }}
                                                    {{ esTarjeta ? 'tarjeta de crédito' : 'cuenta bancaria' }}:
                                                </strong>
                                            </div>
                                        </v-alert>
                                    </v-col>

                                    <v-col v-if="esTarjeta" cols="12" class="py-0 px-3 ">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">NÚMERO:</span>
                                            <span class="font-weight-bold text-subtitle-1 primary--text">
                                                **** **** **** {{ (cuenta.deb_tarjeta || '').slice(-4) }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col v-if="esTarjeta" cols="12" class="py-0 px-3">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Vencimiento:</span>
                                            <span class="font-weight-regular text-subtitle-1">
                                                {{ cuenta.deb_fecvenc || 'N/A' }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col v-if="esTarjeta" cols="12" class="py-0 px-3">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Banco:</span>
                                            <span class="font-weight-regular text-right text-subtitle-1 "
                                                :style="(cuenta.bco_nombre || '').length > 15 ? 'max-width: 200px; word-wrap: break-word; white-space: normal; line-height: 1.2;' : ''">
                                                {{ cuenta.bco_nombre || 'N/A' }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col v-if="!esTarjeta" cols="12" class="py-0 px-3">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">CBU:</span>
                                            <span class="font-weight-regular text-subtitle-1 ">
                                                {{ formatCBU(cuenta.deb_cbu1, cuenta.deb_cbu2) }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col v-if="!esTarjeta" cols="12" class="py-0 px-3">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Banco:</span>
                                            <span class="font-weight-regular text-right text-subtitle-1 "
                                                :style="(cuenta.bco_nombre || '').length > 15 ? 'max-width: 200px; word-wrap: break-word; white-space: normal; line-height: 1.2;' : ''">
                                                {{ cuenta.bco_nombre || 'N/A' }}
                                            </span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="py-0 px-3">
                                        <div class="d-flex justify-space-between align-center">
                                            <span class="font-weight-regular text-subtitle-2">Titular de la
                                                cuenta:</span>
                                            <span class="font-weight-regular text-subtitle-1 ">
                                                {{ user.apellido }}, {{ user.nombres }}
                                            </span>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" class="d-flex justify-end py-0">
                            <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                <v-checkbox v-model="confirmar" :error-messages="v.errors" :label="label" dense>
                                    <template v-slot:label>
                                        <div :class="confirmar ? 'primary--text' : ''">
                                            {{ label }}
                                        </div>
                                    </template>
                                </v-checkbox>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex align-center custom-card-actions-ha">
                    <v-btn elevation='0' @click="volver" class="pa-5" color="secondary" outlined :disabled="confirmar">
                        <v-icon class="mr-2">mdi-chevron-left</v-icon> Atrás
                    </v-btn>
                    <v-spacer />
                    <v-btn elevation='0' type="submit" class="pa-5" color="primary" :disabled="invalid"
                        :loading="loading" @click="enviarTramite">
                        <v-icon class="mr-2">mdi-send-outline</v-icon> Enviar trámite
                    </v-btn>
                </v-card-actions>
            </v-card>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';
export default {
    name: 'FormResumenConfirmacion',
    components: {
        ValidationObserver,
        ValidationProvider,
        SkeletonLoader
    },
    data() {
        return {
            loading: false,
            confirmar: false,
            label: 'Confirmo que los datos son correctos'
        };
    },
    computed: {
        ...mapGetters('mediosDePago', ['pp_aux', 'cuotaUno', 'activos', 'cuenta', 'cuotasFrances']),
        ...mapGetters('auth', ['loadSkeleton', 'user']),

        calculaMontoTotal() {
            const cuotas = Number(this.pp_aux.cancuotas) || 0
            const cuotaInicialNum = Number(this.cuotaUno) || 0
            const cuotaPosteriorNum = Number(this.cuotasFrances) || 0
            if (!cuotas || !cuotaInicialNum || !cuotaPosteriorNum) return ''
            const total = cuotaInicialNum + (cuotas - 1) * cuotaPosteriorNum
            return (this.pp_aux.tipo == 10) ? this.formatMoney(total) : this.formatFloat(total)
        },
        importeCuotaUno() {
            if (this.pp_aux.TipoPago === 2) {
                return this.formatFloat(this.cuotaUno);
            }
            return this.formatMoney(this.cuotaUno);
        },

        tipoPlanTexto() {
            if (this.pp_aux.TipoPago === 1) return 'Plan de pago en pesos';
            if (this.pp_aux.TipoPago === 2) return 'Plan de pago en Módulos';
            return 'N/A';
        },

        esTarjeta() {
            return this.cuenta && this.cuenta.deb_tarjeta;
        },

        cuotasLabel() {
            const cuotas = this.pp_aux.cantCuotas;
            if (cuotas === 2 || cuotas === 3) {
                return 'Sin interés';
            }
            return '';
        },
        cuotasSiguientes() {
            if (this.pp_aux.TipoPago === 2) {
                return this.formatFloat(this.cuotasFrances);
            }
            return this.formatMoney(this.cuotasFrances);
        },

        montoTotal() {
            const cuotas = this.pp_aux.cantCuotas || 1;
            const primera = this.importeCuotaUno || 0;
            const siguientes = this.pp_aux.cuotasSiguientes || 0;

            if (cuotas === 1) return primera;
            return primera + (siguientes * (cuotas - 1));
        }
    },

    methods: {
        ...mapActions('mediosDePago', ['procesaMediosPago', 'nuevoPlanDePago']),

        enviarTramite() {
            this.loading = true;
            this.$emit('mostrar-overlay', true)
            this.nuevoPlanDePago().then(() => {
                this.$emit('confirmar')
            }).catch((error) => {
                console.error('Error al crear nuevo plan de pago:', error);
            }).finally(() => {
                this.loading = false;
                this.$emit('mostrar-overlay', false)
            });
        },

        volver() {
            this.$emit('volver');
        },

        confirmar() {
            this.$emit('confirmar');
        },

        formatMoney(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },
        formatFloat(value) {
            return value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        formatCBU(cbu1, cbu2) {
            if (!cbu1 || !cbu2) return 'N/A';
            return `${cbu1}-${cbu2}`;
        }
    }
};
</script>

<style scoped>
.custom-card-actions-ha {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    padding: 0 16px;
    z-index: 5;
}
</style>